import api from "@/api";
const state = {
  list: { data: [], paging: {} },
  glossary: []
};
const getters = {
  list: state => {
    return state.list;
  },
  glossary: state => {
    return state.glossary;
  }
};
const actions = {
  async getList({ commit }, params) {
    const result = await api.get("/api/v1/suppliers/index/", params);
    if (result && result.status == 200) {
      commit("setList", result.data);
      return result;
    }
    return null;
  },
  async delete({ commit }, payload) {
    const result = await api.put(`/api/v1/suppliers/delete/${payload}/`);
    if (result && result.status == 200) {
      commit("removeItem", payload);
      return result.data.data;
    }
    return null;
  },
  async getGlossary({ commit }) {
    const result = await api.get("/api/v1/suppliers/all/");
    if (result && result.status == 200) {
      commit("setGlossary", result.data.data);
      return result.data.data;
    }
    return null;
  }
};
const mutations = {
  setList: (state, payload) => {
    state.list = payload;
  },
  setGlossary: (state, payload) => {
    state.glossary = payload;
  },
  removeItem: (state, payload) => {
    state.list.data = state.list.data.filter(o => {
      return o.id != payload;
    });
  }
};

export default {
  state,
  getters,
  actions,
  mutations,
  namespaced: true
};
